export const DepartmentType = {
    Educate: 'educate',
    Employ: 'employ',
};
